<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <NewBreadcrumb name="Acquirings" :breadcrumb="breadcrumb"/>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="row mt-2">
            <div class="col-12">
              <div class="card">
                <div class="m-2">
                  <div class="row">
                    <div class="col-6">
                      <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                          <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="javascript:void(0)">Schema</a></li>
                            <li class="breadcrumb-item">{{currentBreadCrumb}}</li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="d-flex align-items-center justify-content-end">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="$router.push({ name: 'add-schema-acquirings-settings' })"
                        >
                          <AddButtonText name="Acquiring" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Min Limit</th>
                      <th>Max Limit</th>
                      <th>Name/Code</th>
                      <th>Payment Method</th>
                      <th>Actions</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in schemaAquirings" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.min_limit?parseFloat(item.min_limit/100).toFixed(3):'N/A'}}</td>
                      <td>{{item.max_limit?parseFloat(item.max_limit/100).toFixed(3):'N/A'}}</td>
                      <td>{{item.aquiring.name+'/'+item.aquiring.code}}</td>
                      <td>{{item.aquiring.payment_method.name+'/'+item.aquiring.payment_method.code}}</td>
                      <td>
                        <button type="button" @click="showTransctionTypeList(item,index)" class="btn btn-primary btn-sm btn-primary mr-1 mt-1">Transaction Types</button>
                        <button type="button" @click="openSettingsUpdateModal(item,index)" class="btn btn-primary btn-sm btn-primary mr-1 mt-1">Update Settings</button>
                        <button type="button" @click="openSettingsModal(item)" class="btn btn-primary btn-sm btn-warning mr-1 mt-1">Settings</button>
                        <div class="custom-control custom-control-success custom-switch mt-1 mb-1">
                          <input :id="'checkbox_'+index" type="checkbox" :true-value="1" :false-value="0"
                                 class="custom-control-input" v-model="item.status" @change="deleteAccquiring(item,index)" />
                          <label class="custom-control-label"
                                 :for="'checkbox_'+index">
                          </label>
                        </div>
                      </td>



                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
<!--          <settingsDetailModal :show="showModal" :data="settingsData"-->
<!--                               @hide="showModal = false"></settingsDetailModal>-->
          <updateSchemaAcquiringSettingsModal :show="showSettingUpdateModal" :settingsData="settingsUpdateData" :recordIndex="recordIndex"
                               @hide="showSettingUpdateModal = false"></updateSchemaAcquiringSettingsModal>

          <currencyModal
              :show="showModal"
              :currencyKey="otherDetailsKey"
              @hide="showModal = false"
              :currencyData="ohterSettingDetailsData">

          </currencyModal>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>

import currencyModal from "@/components/common/modals/currencyPaymentShowDataModal.vue";
import settingsDetailModal from "@/pages/dashboard/schema/settingsDetailModal";
import updateSchemaAcquiringSettingsModal from "@/pages/dashboard/schema/updateSchemaAcquiringSettingsModal";
import {mapState} from "vuex";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";
export default {
  props: ['propFilters'],
  computed: {
    ...mapState(['acquiringSchemaDetailsList'])
  },
  components:{
    AddButtonText,
    // settingsDetailModal,
    updateSchemaAcquiringSettingsModal,
    currencyModal
  },
  mounted() {
    var acquiringSchemaDetailsList = this.$store.getters.getByKey(
        "acquiringSchemaDetailsList"
    );
    this.schemaAquirings = acquiringSchemaDetailsList.row.schema_aquirings
    this.currentBreadCrumb = acquiringSchemaDetailsList.row.name+'/'+acquiringSchemaDetailsList.row.code

    this.breadcrumb= [
      {name: 'App'},
      {name: 'Schema'},
      {name: acquiringSchemaDetailsList.row.name},
    ]
  },
  data() {
    return {
      schemaAquirings:[],
      settingsData:[],
      settingsUpdateData:[],
      showModal:false,
      showSettingUpdateModal:false,
      ohterSettingDetailsData: [],
      otherDetailsKey: [],
      breadcrumb: [
      ],
      currentBreadCrumb:'',
      recordIndex:''
    };
  },
  methods: {
    backTo(){
      let propFilters = this.propFilters
      this.$router.push({name:'schema',params:{propFilters}})
    },
    deleteAccquiring(item,index){

      let requestData = {
        type: 'update',
        schemaAquiringId: item.id,
        minLimit: item.min_limit,
        maxLimit: item.max_limit,
        status: item.status,
      }

      if(item.settings){
        requestData.settings = JSON.stringify(item.settings)
      }

      this.makeRequest('post', 'v1/update-schema-aquiring', requestData).then(callResponse => {

        // this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            var acquiringSchemaDetialListStoreData = this.$store.getters.getByKey(
              "acquiringSchemaDetailsList"
            );
            if (acquiringSchemaDetialListStoreData) {
              acquiringSchemaDetialListStoreData.row.schema_aquirings[index] = callResponse.response.data.data
              this.$store.dispatch("set", acquiringSchemaDetialListStoreData);
            }

          }
        }

      });
    },
    openSettingsModal(row){

      // this.settingsData = item.settings
      // this.showModal =true
      this.showModal = true;
      if (row.settings !== null && row.settings != "[]" ) {
        if (typeof row.settings == "object") {
          let otherDetailsKey = Object.keys(row.settings);
          let data = row.settings;
          this.ohterSettingDetailsData = data;
          this.otherDetailsKey = otherDetailsKey;
        } else if (typeof row.settings == "string") {
          let ohterSettingDetailsData = JSON.parse(row.settings);
          let otherDetailsKey = Object.keys(ohterSettingDetailsData);
          let data = ohterSettingDetailsData;
          this.ohterSettingDetailsData = data;
          this.otherDetailsKey = otherDetailsKey;
        }
      } else {
        this.ohterSettingDetailsData = [];
        this.otherDetailsKey = [];
      }
    },
    openSettingsUpdateModal(item,index){

 

      this.settingsUpdateData = item
      this.recordIndex = index
      this.showSettingUpdateModal =true
    },
    showTransctionTypeList(row,index){
      let data = {
        index: index,
        row: row,
        key: "schemaAcquiringTransactionTypes"
      };
      this.$store.dispatch("set", data);
      this.$router.push({name:'schema-acquirings-transction-type'})
    }
  },
  watch:{
    acquiringSchemaDetailsList(val){
      let data = JSON.parse(val)
      this.schemaAquirings = []
      this.schemaAquirings = data.row.schema_aquirings


    }
  }
};
</script>

